<template>
    <CCard>
        <CCardHeader>
            <CRow>
                <CCol col="8" style="text-align: start">


                    <strong>{{ $t('chequeListDocsPay') }}</strong>

                </CCol>
            </CRow>
            <!--        </div>-->

            <!-- Right aligned nav items -->
            <!--      </CCollapse>-->
        </CCardHeader>

        <CRow>
            <CCol col="3">
                <date-picker
                        :label="$t('components.startDate')"
                        v-model="start_date"></date-picker>
            </CCol>
            <CCol col="3">
                <date-picker
                        :label="$t('components.endDate')"
                        v-model="end_date"></date-picker>

            </CCol>
            <CCol col="1">
                <CButton @click="get_pay_list" color="dark"
                         size="sm">
                    <CIcon size="sm" name="cil-zoom"/>
                </CButton>
            </CCol>

        </CRow>
      <CRow>
        <CCol col="3">
          <CSelect
              :label="$t('tables.status')"
              :value.sync="status_filter"
              horizontal
              :options="[{label:$t('all'),value:-1},{label:$t('noStatus'),value:0},...change_status_statuses]"
          />
        </CCol>
      </CRow>

        <CDataTableFixed
                :items="status_filter==-1 ? items_filtered :items_filtered.filter(x=>x.lastStatusId == status_filter)"
                :fields="fields_cheque"
                striped
                border
                height="300px"
                @row-clicked="table_row_clicked"

                :items-per-page="200"
                hover
                column-filter
                sorter
                pagination
        >


            <template #row="{item,index}">
                <td>
                    <p style="text-align: center">{{ index+1 }}</p>
                </td>
            </template>
            <template #sarRecidDate="{item}">
                <td>
                    <p style="text-align: center">{{ get_date(item.sarRecidDate) }}</p>
                </td>
            </template>

            <template #sodorDate="{item}">
                <td>
                    <p style="text-align: center">{{ get_date(item.sodorDate) }}</p>
                </td>
            </template>

            <template #itemDesc="{item}">
                <td>
                    <p style="text-align: center">{{ item.itemDesc }}</p>
                </td>
            </template>
            <template #accountTitle="{item}">
                <td>
                    <p style="text-align: center">{{ item.accountTitle }}</p>
                </td>
            </template>
            <template #receiverName="{item}">
                <td>
                    <p style="text-align: center">{{ item.receiverName }}</p>
                </td>
            </template>
            <template #masterCode="{item}">
                <td>
                    <p style="text-align: center" v-if="item.masterCode!=null">{{ item.masterCode }}</p>
                </td>
            </template>
            <template #docNoCode="{item}">
                <td>
                    <p style="text-align: center">
                        <a :href="'/dashboard/accounting/show-accounting-doc/'+item.docNo" target="_blank">
                            {{ item.docNoCode }}
                        </a>
                    </p>
                </td>
            </template>
            <template #price="{item}">
                <td>
                    <p style="text-align: right">{{ get_currency(item.price) }}</p>
                </td>
            </template>
            <template #lastStatus="{item}">
                <td>
                    <p  style="text-align: center;padding:3px;font-size: 11px;"
                       class=" text-danger"
                       @click="open_change_status_cheque(item)">{{item.lastStatus}}</p>

                  
                  <p>
                    {{item.lastStatusSummary}}
                  </p>
                </td>
            </template>

            <template #caption="{item}">
                <tr class="total-table">
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                        {{ $t('totalSum') }}
                    </td>
                    <td>
                        {{ get_currency(calculate_items(items.filter(x=>x.lastStatusId==0), "price")) }}

                    </td>
                    <td>

                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                </tr>
            </template>
        </CDataTableFixed>

        <CModal
                :show.sync="change_status_dialog"
                :no-close-on-backdrop="true"
                color="transparent"
                border-color="primary"
                :title="$t('components.changeStatus')"
        >
            <CRow v-if="change_status_item.partyName!=null">
                <CCol col="12" style="font-weight: bold;margin-bottom: 5px">{{$t('tables.customer')}} :
                    {{change_status_item.partyName}}
                </CCol>
                <CCol col="6" style="font-weight: bold;margin-bottom: 5px">{{$t('tables.amount')}} :
                    {{get_currency(change_status_item.price)}}
                </CCol>

                <CCol col="6" style="font-weight: bold;margin-bottom: 5px">{{$t('tables.bankAccTitle')}} :
                    {{change_status_item.accountTitle}}
                </CCol>
                <!--        <CCol col="6" style="font-weight: bold;margin-bottom: 5px">{{$t('AccountNo')}} : {{change_status_item.bankAccount}}</CCol>-->

                <CCol col="6" style="font-weight: bold;margin-bottom: 5px">{{$t('components.passDate')}} :
                    {{get_date(change_status_item.sarRecidDate)}}
                </CCol>

                <!--        <CCol col="6" style="font-weight: bold;margin-bottom: 5px">{{$t('SortCode')}} : {{(change_status_item.sortCode)}}</CCol>-->
                <CCol col="6" style="font-weight: bold;margin-bottom: 5px">{{$t('chequeNumber')}} :
                    {{change_status_item.serial}}
                </CCol>


            </CRow>
            <CRow>
                <CCol col="12">

                    <CRow form class="form-group">
                        <label tag="label" sm="12" class="col-form-label">
                            {{$t('docDate')}}
                        </label>
                        <CCol sm="12">
                            <date-picker
                                    v-model="doc_date"
                                    :min="get_min_doc_date()"
                                    :max="get_max_doc_date()"
                            ></date-picker>
                        </CCol>
                    </CRow>

                    <CSelect
                            :label="$t('tables.status')"
                            :value.sync="change_status_selected_status"
                            :options="change_status_statuses"
                    />
                    <CSelect
                            v-if="change_status_selected_status==1"
                            :label="$t('tables.bank')"
                            :value.sync="selected_bank"
                            :options="banks"
                    />
                    <CSelect
                            v-if="change_status_selected_status==2"

                            :label="$t('components.cash')"
                            :value.sync="selected_cashier"
                            :options="cashiers"
                    />
                    <CInput
                            :label="$t('tables.summary')"
                            v-model="change_status_desc"
                    />


                </CCol>
            </CRow>
            <template #footer>
                <CButton @click="change_cheque_status_confirm()"
                         color="success"
                >{{ $t("buttons.ok") }}
                </CButton>
                <CButton
                        @click="change_status_dialog = false"
                        color="danger"
                >{{ $t("buttons.cancel") }}
                </CButton>
            </template>
        </CModal>
      <CModal
          :show.sync="cheque_status_dialog"
          :no-close-on-backdrop="true"
          color="transparent"
          border-color="primary"

          :title="$t('components.changeStatus')"
      >

        <CDataTableFixed
            :items="cheque_status_items"
            :fields="cheque_status_fields"
            striped
            border

            column-filter
            :items-per-page="200"
            hover
            sorter
            pagination
        >


          <template #row="{item,index}">

            <td style="text-align: center">
              <p>{{ index + 1 }}</p>

            </td>

          </template>
          <template #createdAt="{item}">
            <td>
              <p>{{ get_date(item.createdAt) }}</p>
            </td>
          </template>

        </CDataTableFixed>

        <template #footer>

          <CButton
              @click="cheque_status_dialog = false"
              color="danger"
          >{{ $t("buttons.close") }}
          </CButton>
        </template>
      </CModal>


    </CCard>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'
    import BTabs from "../../tabs/BTabs";
    import AddPayCash from "./AddPayCash";
    import AddPayCheque from "./AddPayCheque";
    import PayingOrders from "./PayingOrders";

    const simulateAsyncOperation = fn => {
        setTimeout(fn, 200)
    }
    export default {
        name: 'PayOperation',
        components: {
            Treeselect,
            BTabs,
            AddPayCash,
            AddPayCheque,
            PayingOrders,
        },

        data() {
            return {
              cheque_status_dialog:false,
              cheque_status_items:[],
              cheque_status_fields:[
                {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%;padding:0px'},
                {key: 'createdAt', label: this.$t('date'), _style: 'padding:0px'},

                {key: 'createdBy', label: this.$t('user'), _style: 'padding:0px'},
                {key: 'accountName', label: this.$t('AccountName'), _style: 'padding:0px'},
                {key: 'recSummary', label: this.$t('tables.summary'), _style: 'padding:0px'},
                {key: 'tafsiliName', label: this.$t('tafsiliTitle'), _style: 'padding:0px'},

              ],
              table_clicks:0,
              table_clicks_timer:null,
                start_date: '',
                end_date: '',
                doc_date: '',

                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                master_id: null,
                master_types: [{id: '1', label: this.$t('factor')}, {id: '2', label: this.$t('debtors')}, {
                    id: '3',
                    label: this.$t('persons')
                }],
                active_tab: 0,

                change_status_dialog: false,
                change_status_item: {},
                change_status_desc: '',
                change_status_selected_status: 1,
                status_filter: 0,
                change_status_statuses: [],

                search_reference_master: 0,

                date_cash: '',
                date_cheque: '',
                summary: '',

                cashiers: [],
                banks: [],
                terminals: [],
                selected_bank: 0,
                selected_cashier: 0,
                selected_payer: 0,
                selected_receiver_cash: null,
                selected_receiver_cheque: null,
                doc_types: [
                    {value: 2, label: this.$t('components.cash')},
                    {
                        value: 6, label: this.$t('components.bank')
                    }, {value: 1, label: this.$t('components.pos')}],
                selected_doc_type: 2,
                status_form: 0,
                price: '',

                items_accounting_groups: [],
                selected_accounting_group: null,
                items_accounting_sub_groups: [],
                selected_accounting_sub_group: null,
                items_accounting_data: [],


                items_pay_cash: [{}],

                items_pay_cheque: [{}],
                searched_person: [],
                document_person: null,
                document_person_cheque: null,
                search_user_async: true,
                load_persons({action, searchQuery, callback}) {

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);
                            var url = "GetAllPersons";

                            formData.append('IsVendor', true);
                            formData.append('IsWorker', false);
                            formData.append('IsCustomer', false);
                            formData.append('IsActive', 0);

                            axios.post(url, formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {
                                    console.log(error);
                                });
                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
                    }
                },
                normalizer_documents(node) {
                    return {
                        id: node.id,
                        label: node.label,
                    }
                },

                normalizer_refrence(node) {
                    return {
                        id: node.factorMasterId,
                        label: node.factorMasterId,
                    }
                },

                items: [],
                fields_cheque: [
                    {
                        key: 'row',
                        label: this.$t('tables.row'),
                        sorter: false,
                        _style: 'width:3%;padding:0px;text-align:center'
                    },
                    {key: 'docNoCode', label: this.$t('docNumber'), _style: 'padding:0px;text-align:center'},
                    {key: 'masterCode', label: this.$t('reference'), _style: 'padding:0px;text-align:center'},
                    {key: 'partyName', label: this.$t('tables.customer'), _style: 'width:20%;padding:0px;text-align:center'},
                    {key: 'price', label: this.$t('tables.amount'), _style: 'padding:0px;text-align:center'},
                    {
                        key: 'accountTitle',
                        label: this.$t('tables.bankAccTitle'),
                        _style: 'padding:0px;text-align:center'
                    },

                    {
                        key: 'sarRecidDate',
                        label: this.$t('components.passDate'),
                        _style: 'padding:0px;text-align:center'
                    },
                    // {
                    //     key: 'receiverName',
                    //     label: this.$t('components.receiver'),
                    //     _style: 'padding:0px;text-align:center'
                    // },
                    // {key: 'payType', label: this.$t('tables.payType'), _style: 'padding:0px;text-align:center'},
                    // {key: 'payType', label: this.$t('tables.bank'), _style: 'padding:0px;text-align:center'},
                    {key: 'sodorDate', label: this.$t('components.payDate'), _style: 'padding:0px;text-align:center'},
                    {key: 'serial', label: this.$t('chequeNumber'), _style: 'padding:0px;text-align:center'},
                    {key: 'itemDesc', label: this.$t('tables.summary'), _style: 'padding:0px;text-align:center'},
                    {key: 'lastStatus', label: this.$t('tables.status'), _style: 'padding:0px;text-align:center'},
                ],
                items_cheque: [],
                get_items: [1],
                cheque_banks: [],
                items_filtered: [],
            }
        }, mounted() {
            this.date_cash = this.get_today();
            this.date_cheque = this.get_today();
            this.doc_date = this.get_today();

            this.start_date = this.get_day_before_today(1);
            this.end_date = this.get_today();

            // this.$root.root_validate_errors = [];
// this.$root.header_action.innerHTML = this.$refs['action_bar'].innerHTML
            this.get_banks();
            this.get_cashiers();

            this.get_lists_groups();
            this.get_pay_list();
            this.get_pay_status();

            bus.$on("update_add_pay_cheque", (data) => {
                // alert(data);
                this.get_pay_list();

            });
            bus.$on(this.confirm_delete_name + "add_status", (data) => {
                // alert(data);
                this.change_status_dialog = true

                if (data == "true") {
                    this.change_cheque_status();
                }


            });

        }, watch: {
            // 'start_date': function () {
            //   this.get_pay_list();
            // },
            // 'end_date': function () {
            //   this.get_pay_list();
            // }
        },
        computed: {},
        methods: {
          table_row_clicked(item, index) {

            this.table_clicks++;
            if (this.table_clicks == 1) {
              this.table_clicks_timer = setTimeout(() => {
                // this.result.push(event.type);
                this.table_clicks = 0
              }, 500);
            } else if (this.table_clicks > 1) {
              this.table_clicks = 0

              clearTimeout(this.table_clicks_timer);
              this.cheque_status_list(item.id)
            }

          },
          cheque_status_list(id) {
            var self = this;

            const formData = new FormData();


            formData.append('ChequeId', id);

            this.cheque_status_dialog = true;


            axios.post('GetPayChequeStatusRptList', formData, {}).then(function (response) {

              var content_data = response.data;

              // items = content_cats.orders;
              if (content_data.statusCode == 0) {
                self.cheque_status_items = response.data.data
                self.cheque_status_dialog = true;

              } else {
                self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

              }

            })
                .catch(function (error) {

                  console.log(error);
                });

          },

          open_change_status_cheque(item) {
            if(item.lastStatusId!=0){
            return false
            }
                this.change_status_dialog = true;
                this.change_status_item = item;
            },
            get_pay_list() {
                var self = this;

                const formData = new FormData();


                formData.append('FromDate', this.start_date);
                formData.append('ToDate', this.end_date);


                axios.post('GetFactorPayCheques', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.items = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                        self.items_filtered = self.items
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_pay_status() {
                var self = this;

                const formData = new FormData();


                axios.post('GetPayableChequeStatusList', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        // self.change_status_statuses = self.sort_array([],content_data.data,"id","title")

                        content_data.data.forEach(function (val) {
                            val.label = val.title
                            val.value = val.id
                        })
                        self.change_status_statuses = content_data.data

                        self.change_status_selected_status = self.change_status_statuses[0].value
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            change_cheque_status_confirm() {
                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("sureToConfirm"), [this.$t("dialogs.ok")], this.confirm_delete_name + "add_status");
                this.change_status_dialog = false

            },
            change_cheque_status() {
                var self = this;

                const formData = new FormData();


                formData.append('docDate', this.doc_date);
                formData.append('ChequeId', this.change_status_item.id);
                formData.append('StatusId', this.change_status_selected_status);
                if (this.change_status_selected_status == 2) {//cash
                    formData.append('TafsiliId', this.selected_cashier);
                    formData.append('AccountId', this.cashiers.filter(x => x.id == this.selected_cashier)[0].accountId);
                }
                if (this.change_status_selected_status == 1) {//bank
                    formData.append('TafsiliId', this.selected_bank);
                    formData.append('AccountId', this.banks.filter(x => x.id == this.selected_bank)[0].accountId);

                }
                formData.append('RecSummary', this.change_status_desc);
                this.change_status_dialog = false;


                axios.post('AddPayChequeStatus', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.get_pay_list()
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            get_banks() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetBankAccounts', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.banks = self.sort_array([], content_data.data, 'id', 'bankAccTitle')
                        self.selected_bank = self.banks[0].value
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_cashiers() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);

                axios.post('GetCashierTitles', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.cashiers = self.sort_array(
                            self.cashiers, response.data.data.filter(x => x.accountId == 70),
                            'id', 'boxTitle');
                        self.selected_cashier = self.cashiers[0].value
                        self.get_terminals();

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_terminals() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetBankTerminals', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.terminals = content_data.data;
                        self.cashiers = self.sort_array(
                            self.cashiers, response.data.data,
                            'id', 'terminalTitle');
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            get_lists_groups() {
                var self = this;
                self.items_accounting_groups = [];
                // GetChequeInfo
                // FirstDate
                // SecondDate
                // MasterId => 0 biad ya por bede
                const formData = new FormData();
                var url = "Get_AllAccountingGroups";

                // formData.append("id", 1);

                axios.post(url, formData, {}).then(function (response) {

                        var content_data = response.data;

                        if (content_data.statusCode == 0) {


                            self.items_accounting_data = response.data.data.map((item, row_id) => {
                                return {...item, row_id}
                            })

                            var obj2 = {
                                label: "All",
                                id: 0,
                            }
                            self.items_accounting_groups.push(obj2)

                            // console.log(self.data);
                            response.data.data.forEach((val) => {
                                if (val.parentId == 0) {

                                    self.get_childrens_one_sub(val.id, self.items_accounting_data).forEach((val2) => {

                                        self.get_childrens_one_sub(val2.id, self.items_accounting_data).forEach((val3) => {
                                            var obj2 = {
                                                label: val3.accountName,
                                                code: val3.accountCode,
                                                id: val3.id,
                                            }

                                            self.items_accounting_groups.push(obj2)

                                        });
                                    });

                                }

                            });
                            // self.filter_data();

                        } else {
                            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                        }

                    }
                )
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_lists_sub_groups() {
                var self = this;
                this.items_accounting_sub_groups = []
                this.selected_accounting_sub_group = null


                self.get_childrens_one_sub(this.selected_accounting_group, self.items_accounting_data).forEach((val2) => {
                    var obj2 = {
                        label: val2.accountName,
                        code: val2.accountCode,
                        id: val2.id,
                    }
                    self.items_accounting_sub_groups.push(obj2)

                });


            },
            get_childrens_one_sub(parent_id, list) {
                var array = [];
                list.forEach((val2) => {

                    if (parent_id == val2.parentId) {
                        // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
                        array.push(val2);


                    }
                });
                return array;
            },


        }
    }

</script>
